<template>
  <div class="">
    <div class="container">
      <div class="rule-btn" @click="jumpRules">活动规则</div>
      <img
        class="bg1"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_old_member?curtime=1"
        alt=""
      />
      <PaoMaDeng
        :delay="0"
        :speed="40"
        :content="winnerList"
        class="paomadeng"
        v-if="winnerList.length"
      >
        <div
          class="paomadeng-item"
          v-for="(item, index) in winnerList"
          :key="index"
        >
          <div class="avatar-container">
            <img class="item-avatar" :src="item.head_img" alt="" />
          </div>
          <div class="item-text">
            {{
              item.truename +
              ' ' +
              item.phone +
              ' 领取了' +
              item.num +
              '张' +
              item.prize_name
            }}
          </div>
        </div>
      </PaoMaDeng>
      <div class="btn-content">
        <div class="btn-item btn-left" @click="bindInviteFriend">
          <span>邀请好友</span><span class="num">（剩余{{ leftNum }}次）</span>
        </div>
        <div class="btn-item btn-right" @click="bindInviteNum">
          查看邀请进度
        </div>
      </div>
    </div>
    <van-overlay :show="showPoster" @click="showPoster = false">
      <PosterComponent v-if="showPoster" @close="bindClose" />
    </van-overlay>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#999"
      color="#999"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import PaoMaDeng from '../goddess-festival/ponents/paomadeng.vue'
import PosterComponent from './components/poster.vue'
export default {
  components: {
    PaoMaDeng,
    PosterComponent
  },
  data() {
    return {
      loaded: false,
      showPoster: false,
      leftNum: 0, //剩余次数
      inviteId: '', //邀请id
      ruleData: null, //规则
      winnerList: [],
      activityId: 1 //活动id
    }
  },
  created() {
    this.getData()
    this.getForward()
  },
  methods: {
    getForward() {
      let params = {
        activity_id: this.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/activityMarquee', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.winnerList = res.data || []
          }
        })
        .catch(() => {})
    },
    getData() {
      let params = {
        activity_id: this.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/createReceiveCode', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.leftNum = res.data.left_time
            this.inviteId = res.data.invitation_id
            this.ruleData = res.data.activity_rule
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    bindInviteNum() {
      if (!this.inviteId) {
        return
      }
      this.$router.push({
        path: '/camp-invite/inviteSchedule',
        query: {
          activityId: this.activityId,
          inviteId: this.inviteId
        }
      })
    },
    bindInviteFriend() {
      if (this.leftNum <= 0) {
        this.$dialog
          .alert({
            title: '提示',
            message: '哎呀，好友邀请次数已使用完啦，下次早一点哦～'
          })
          .then(() => {
            // on close
          })
        return
      }
      this.showPoster = true
    },
    jumpRules() {
      if (!this.inviteId) {
        return
      }
      this.$router.push({
        path: '/camp-invite/rules',
        query: {
          type: 1
        }
      })
    },
    bindClose() {
      this.showPoster = false
    }
  }
}
</script>
<style lang="scss" scoped>
.bg1 {
  width: 100%;
}
.paomadeng {
  width: 100%;
  position: absolute;
  left: 0;
  top: 520px;
  padding-left: 60px;
  box-sizing: border-box;
}
.paomadeng-item {
  display: flex;
  align-items: center;
  margin-right: 8px;
  height: 40px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 12px;
  padding: 4px 15px;
  box-sizing: border-box;
  .avatar-container {
    position: relative;
  }
  .item-active {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 40%;
    bottom: 50%;
    z-index: 1;
  }
  .item-avatar {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    overflow: hidden;
    margin-right: 10px;
    object-fit: cover;
  }
  .item-text {
    white-space: nowrap;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    line-height: 18px;
  }
}
.btn-content {
  position: fixed;
  width: 100%;
  bottom: 0px;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  height: 48px;
  // IOS底部兼容
  height: calc(48px + 0.5 * constant(safe-area-inset-bottom));
  height: calc(48px + 0.5 * env(safe-area-inset-bottom)); //兼容 IOS>11.2;
  background: #755b9b;
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  .btn-item {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-left {
    width: 228px;
    background: #58417a;
  }
  .num {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #ffffff;
  }
  .btn-right {
    flex: 1;
  }
}
.rule-btn {
  position: fixed;
  right: 0;
  top: 110px;
  width: 32px;
  display: flex;
  text-align: center;
  background: #6f60a2;
  border-radius: 8px 0px 0px 8px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 15px;
  z-index: 1;
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
  z-index: 1;
}
</style>
